<template>
  <button
      class="basketButton"
    @click="$router.push({name: 'CartView'})"
  >
    Корзина
    <svg class="lucide lucide-shopping-cart w-6 h-6" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
         stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="21" r="1"></circle>
      <circle cx="19" cy="21" r="1"></circle>
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
    </svg>
  </button>
</template>

<script>
export default {
  name: "MainHeaderBasketButton"
}
</script>



<style lang="scss" scoped>


.basketButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    cursor: pointer;
    transition: colors 0.3s; // Можно указать другую продолжительность или свойства

    &:focus-visible {
      outline: none;
      ring: 1px solid var(--ring-color, #d1d5db); // Убедитесь, что переменная `--ring-color` определена
    }

    &:disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    svg {
      pointer-events: none;
      size: 4px; // Корректная реализация для размера
      flex-shrink: 0;
    }

    border: 1px solid var(--cd-text);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    padding: 0.5rem 1rem; // px-4 py-2
    height: 50px;
    width: 148px;
    gap: 1.5rem;
    border-radius: 100px;
    background-color: transparent;
    color: var(--cd-text);
    font-family: var(--cd-default-font);
    font-weight: var(--cd-default-font-weight);
    font-size: var(--cd-text-m-font-size);
    letter-spacing: normal;
    line-height: normal;
    font-style: normal;

    &:hover {
      background-color: var(--cd-button-bg-color);
      color: var(--cd-highlight-text);
    }
  }
</style>
